import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <div className="bg-[var(--app-bg)]">
      <Outlet />
    </div>
  );
};

export default AdminLayout;
